<section class="content">
    <div class="card" style="padding:25px">

        <div class="container-fluid">
            <div class="row">
                <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
                    {{title}}
                </div>
            </div>

            <br>
            <div class="form-row">
                <div class="col-2">
                    <mat-list-item class="primary-imenu-item" role="listitem">
                        <mat-form-field class="select-form"
                            style="border: 2px solid lightgrey; padding: 11px;  border-radius: 18px;margin-left:-15px">
                            <mat-label>Select business Type</mat-label>
                            <mat-select [(ngModel)]="selectbusinesstype" (ngModelChange)="onbusinessselecttype()">
                                <mat-option *ngFor="let business of business_types"
                                    [value]="business.id">{{business.name}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </mat-list-item>
                </div>
                <div class="col-2" *ngIf="showBusinessGroupDropdown">
                    <mat-list-item class="primary-imenu-item" role="listitem">
                        <mat-form-field class="select-form"
                            style="border: 2px solid lightgrey; padding: 11px;  border-radius: 18px;margin-left:-15px">
                            <mat-label>Select business Group</mat-label>
                            <mat-select [(ngModel)]="selectbusinessgroups" (ngModelChange)="onbusinessselectgroup()">
                                <mat-option [value]="0">Reliance</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </mat-list-item>
                </div>
                <div class="col-2" *ngIf="showBusinessNamedropdown">
                    <mat-list-item class="primary-imenu-item" role="listitem">
                        <mat-form-field class="select-form"
                            style="border: 2px solid lightgrey; padding: 11px;  border-radius: 18px;margin-left:-15px">
                            <mat-label>Select business Name</mat-label>
                            <mat-select [(ngModel)]="selectbusinessgroup" (ngModelChange)="onbusinessselectname()">
                                <mat-option *ngFor="let business of business_name['business_types']"
                                    [value]="business.business_code">{{business.name}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </mat-list-item>
                </div>
                <div class="col">
                    <button mat-raised-button color="primary" (click)="checkBoothExists()" type="button"
                        style="margin-top: 7px; margin-left: 18px;">Confirm</button>
                </div>
            </div>
            <div *ngIf="business_available">
                <div class="row">
                    <div class="col-7">
                        <div class="card"
                            style="box-shadow: 0px 0px 5px 0px #535252; padding: 15px;font-size: 15px;  margin-top: 18px;">
                            <div class="row">
                                <div class="col-1"></div>
                                <div class="col text-center">
                                    <h4 style="font-weight: normal;">Business group Details</h4>
                                </div>
                                <div class="col-2"></div>
                            </div>

                            <div class="row" style="padding: 10px;">
                                <!-- <div class="col-1"></div> -->
                                <div class="col" *ngIf="Buisness_Name">
                                    <b>Business Name:</b> {{ business_details['business_name']['Buisness_Name'] }}
                                </div>
                                <div class="col" *ngIf="Business_Group_Name">
                                    <b> Business Group Name:</b> {{ business_details['business_name']['Business_Group_Name'] }}
                                </div>
                                <div class="col">
                                    <b>Wallet Balance:</b> {{business_details['business_wallet_balance']}}
                                </div>
                            </div>


                        </div>
                        <div class="card"
                            style="box-shadow: 0px 0px 5px 0px #535252; padding: 15px;font-size: 15px; margin-top: 18px;">
                            <div class="row">
                                <div class="col-1"></div>
                                <div class="col text-center">
                                    <h4 style="font-weight: normal;">Payment</h4>
                                </div>
                                <div class="col-2">
                                    <button *ngIf="selected_payment_mode == 3" mat-stroked-button color="warn"
                                        (click)="clearBankDetails()">clear</button>
                                </div>
                            </div>
                            <div class="row" style="margin-left: 45px; margin-top: 16px;">
                                <div class="col-1"></div>
                                <div class="col-3">
                                    <mat-form-field appearance="outline" style="padding: 0px;">
                                        <mat-label>Select the Payment Mode</mat-label>
                                        <mat-select [(ngModel)]="selected_payment_mode"
                                            (ngModelChange)="changePayment()">
                                            <mat-option *ngFor="let mode of payment_modes" [value]="mode.id">
                                                {{mode.name}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-3">
                                    <mat-form-field appearance="outline" style="padding: 0px;margin-left: 75px;"
                                        *ngIf="selected_payment_mode == 2">
                                        <mat-label>Amount ₹ </mat-label>
                                        <input matInput class="inputs" type="number" [(ngModel)]="amount"
                                            placeholder="amount" (keydown.enter)="addMoney()">
                                        <!-- <span matPrefix style="top: -20px;">&nbsp;</span> -->
                                    </mat-form-field>
                                </div>
                                
                                <div class="col-3">
                                    <mat-form-field appearance="outline" style="padding: 0px;margin-left: 75px;"
                                        *ngIf="selected_payment_mode == 1">
                                        <mat-label>Amount ₹ </mat-label>
                                        <input matInput class="inputs" type="number" [(ngModel)]="selectamount"
                                            placeholder="amount" (keydown.enter)="addMoney()">
                                        <!-- <span matPrefix style="top: -20px;">&nbsp;</span> -->
                                    </mat-form-field>
                                </div>
                                <div class="col-3">
                                    <mat-form-field appearance="outline" style="padding: 0px;margin-left: 75px;"
                                        *ngIf="selected_payment_mode == 1">
                                        <mat-label>Transaction Id </mat-label>
                                        <input matInput class="inputs" type="number" [(ngModel)]="Transaction_Id"
                                            placeholder="Transaction Id" (keydown.enter)="addMoney()">
                                        <!-- <span matPrefix style="top: -20px;">&nbsp;</span> -->
                                    </mat-form-field>
                                </div>
                                <div class="col-3">
                                    <mat-form-field appearance="outline" style="padding: 0px;margin-left: 342px;"
                                        *ngIf="selected_payment_mode == 1">
                                        <input matInput [matDatepicker]="picker" placeholder="Choose a date"
                                            [(ngModel)]="date">
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col-3"></div>
                            </div>
                            <div class="div" *ngIf="selected_payment_mode == 3">
                                <form [formGroup]="add_money_form">
                                    <div class="row" style="margin-left: 9px;">
                                        <div class="col-3">

                                            <mat-form-field appearance="outline" style="padding: 0px;">
                                                <mat-label>Bank Name</mat-label>
                                                <input matInput class="inputs" type="text" placeholder="Placeholder"
                                                    formControlName='bank_name'>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-3" style="margin-left: 48px;">
                                            <mat-form-field appearance="outline" style="padding: 0px;">
                                                <mat-label>Branch Name</mat-label>
                                                <input matInput class="inputs" type="text" placeholder="branch name"
                                                    formControlName='branch_name'>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-3" style="margin-left: 48px;">
                                            <mat-form-field appearance="outline" style="padding: 0px;">
                                                <mat-label>IFSC Code</mat-label>
                                                <input style="text-transform: uppercase;" matInput class="inputs"
                                                    type="text" placeholder="ifsc code" formControlName='ifsc_code'>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row" style="margin-left: 9px;">
                                        <div class="col-3">
                                            <mat-form-field appearance="outline" style="padding: 0px;">
                                                <mat-label>MICR Code</mat-label>
                                                <input matInput class="inputs" type="text" placeholder="Placeholder"
                                                    formControlName='micr_code'>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-3" style="margin-left: 48px;">
                                            <mat-form-field appearance="outline" style="padding: 0px;">
                                                <mat-label>Account Holder Name</mat-label>
                                                <input matInput class="inputs" type="text"
                                                    placeholder="account holder name"
                                                    formControlName='account_holder_name'>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-3" style="margin-left: 48px;">
                                            <mat-form-field appearance="outline" style="padding: 0px;">
                                                <mat-label>Account Number</mat-label>
                                                <input matInput class="inputs" type="number"
                                                    placeholder="account number" formControlName='account_number'>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row" style="margin-left: 66px; margin-top: 16px;">
                                        <div class="col-3" style="margin-left: 48px;">
                                            <mat-form-field appearance="outline" style="padding: 0px;">
                                                <mat-label>Cheque Number </mat-label>
                                                <input matInput class="inputs" type=number placeholder="cheque number"
                                                    formControlName='cheque_number'>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-3" style="margin-left: 61px;">
                                            <mat-form-field appearance="outline" style="padding: 0px;">
                                                <mat-label>Date of cheque Issued </mat-label>
                                                <input matInput class="inputs" [max]="min_date" type="date"
                                                    placeholder="date of cheque issued"
                                                    formControlName='cheque_issue_date'>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row" style="padding-bottom: 26px;">
                                        <div class="col text-center">
                                            <button (click)="addMoney()" [disabled]="!add_money_form.valid"
                                                mat-raised-button color="primary">Add
                                                money</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="row" style="padding-bottom: 26px;" *ngIf="selected_payment_mode != 3">
                                <div class="col text-center">
                                    <button (click)="addMoney()" mat-raised-button color="primary">Add money</button>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</section>